import { z } from 'zod'

const QuotaItem = z.object({
  used: z.string(),
  hard: z.string()
})

export const K8sDashboardOverview = z.object({
  quota: z.object({
    cpu: QuotaItem,
    memory: QuotaItem,
    pvcs: QuotaItem,
    storage: QuotaItem
  }),
  workloads: z.object({
    deployments: z.object({ total: z.number(), ready: z.number() }),
    statefulsets: z.object({ total: z.number(), ready: z.number() }),
    daemonsets: z.object({ total: z.number(), ready: z.number() }),
    jobs: z.object({ active: z.number(), succeeded: z.number(), failed: z.number() }),
    cronjobs: z.object({ total: z.number() })
  })
})
export type K8sDashboardOverview = z.infer<typeof K8sDashboardOverview>

export const K8sWorkload = z.object({
  name: z.string(),
  kind: z.string(),
  replicas: z.number(),
  ready_replicas: z.number(),
  age: z.string(),
  health: z.string(),
  health_detail: z.string().optional()
})
export type K8sWorkload = z.infer<typeof K8sWorkload>

export const K8sWorkloadCost = z.object({
  name: z.string(),
  kind: z.string(),
  cpu_cents: z.number(),
  memory_cents: z.number(),
  storage_cents: z.number(),
  total_cents: z.number(),
  percent: z.number()
})
export type K8sWorkloadCost = z.infer<typeof K8sWorkloadCost>

export const K8sWorkloadEfficiency = z.object({
  name: z.string(),
  kind: z.string(),
  cpu_requested: z.number(),
  cpu_limit: z.number(),
  cpu_used: z.number(),
  cpu_p95: z.number().optional().default(0),
  cpu_efficiency: z.number(),
  memory_requested: z.number(),
  memory_limit: z.number(),
  memory_used: z.number(),
  memory_p95: z.number().optional().default(0),
  memory_efficiency: z.number(),
  savings_cents: z.number()
})
export type K8sWorkloadEfficiency = z.infer<typeof K8sWorkloadEfficiency>

export const K8sPod = z.object({
  name: z.string(),
  status: z.string(),
  restarts: z.number(),
  age: z.string(),
  containers: z.array(
    z.object({
      name: z.string(),
      image: z.string(),
      ready: z.boolean(),
      state: z.string()
    })
  )
})
export type K8sPod = z.infer<typeof K8sPod>

export const K8sEvent = z.object({
  type: z.string(),
  reason: z.string(),
  message: z.string(),
  involved_object: z.string(),
  first_timestamp: z.number(),
  last_timestamp: z.number(),
  count: z.number()
})
export type K8sEvent = z.infer<typeof K8sEvent>

export const K8sPVC = z.object({
  name: z.string(),
  capacity: z.string(),
  used_bytes: z.number(),
  capacity_bytes: z.number(),
  usage_percent: z.number(),
  status: z.string(),
  access_modes: z.array(z.string()),
  storage_class: z.string(),
  mounted_by: z.string(),
  age: z.string(),
  autoscaling_enabled: z.boolean(),
  autoscaling_threshold: z.string().optional(),
  autoscaling_limit: z.string().optional(),
  billable_capacity: z.string().optional()
})
export type K8sPVC = z.infer<typeof K8sPVC>
